import { Stack } from "@mui/system";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import { useState } from "react";
import { Button } from "@mui/material";
import axios from "axios";
function VoteButton({ videoId }) {
  const URL =
    "https://7168661e-436d-4a67-bc22-cb1049597751.mock.pstmn.io/v1/videos/";
  // /v1/videos/:videoId/votes
  const [upVotes, setUpVotes] = useState(0);
  const [downVotes, setDownVotes] = useState(0);

  async function handleUpVote() {
    const body = {
      vote: "upVote",
      change: "increase",
    };
    try {
      const response = await axios.patch(URL + `${videoId}/votes`, body);
      console.log('patch response upvote', response)
    } catch (error) {}
  }

  async function handleDownVote() {
    const body = {
      "vote": "downVote",
      "change": "increase"
  };
    try {
      const response = await axios.patch(URL + `${videoId}/votes`, body);
      console.log('patch response downvote', response)
    } catch (error) {}
  }
  return (
    <Stack direction="row" spacing={2}>
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={handleUpVote}
        startIcon={<ThumbUpIcon />}
      >
        {upVotes}
      </Button>
      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={handleDownVote}
        startIcon={<ThumbDownIcon />}
      >
        {downVotes}
      </Button>
    </Stack>
  );
}

export default VoteButton;
